<template>
  <div>
    <renew-contracts :selectedRenewItem="selectedRenewItem" @onClose="resetDataSelected"
      :openRenewDialog="openRenewDialog" :marketId="marketId" :projectId="projectId" @onRenewContract="onRenewContract"
      @onSuccessSetting="$emit('reloadContract')"></renew-contracts>
    <CheckinWarning :areas="areas" @reloadContract="reloadContract" />
    <CheckMeterOffline :meterNotification="meterNotification" @clickDialogGoTo="clickDialogGoTo"/>

    <div class="flex justify-between items-center my-5">
      <div v-if="currentTable" class="stall-total">
        {{ $t('area.total_stall', { count: currentTable.filteredItems ? currentTable.filteredItems.length : 0 }) }}
      </div>
      <ExplanationStatus :viewType="'table'" />
    </div>
    <v-card>
      <v-data-table
        :headers="areaHeaders"
        :items="areaItems"
        sort-by="order"
        :items-per-page="50"
        :search="search"
        ref="dataTableAreas"
        class="data-table-areas"
        @update:page="shouldShowMoreChip"
        @update:items-per-page="shouldShowMoreChip"
        :no-data-text="$t('noinfo')"
        :no-results-text="$t('no_matching_records_found')"
      >
        <template v-slot:item.order="{ index }">{{ index + 1 }}</template>
        <template v-slot:header.name="{ header }">
          <span>
            <div class="text-nowrap-table text-center" style="min-width:180px">{{ header.text }}</div>
          </span>
        </template>
        <template v-slot:header.businessName="{ header }">
          <div class="text-nowrap-table text-center" style="min-width:190px">{{ header.text }}</div>
        </template>
        <template v-slot:header.contractName="{ header }">
          <div class="text-nowrap-table text-center" style="min-width:190px;">{{ header.text }}</div>
        </template>
        <template v-slot:body.prepend>
          <tr>
            <td class="text-center">
              <v-icon>mdi-filter-multiple-outline</v-icon>
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.areaName" type="text" :label="$t('area.area_name')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-select
                v-model="filterData.areaSize"
                :items="filterOption.areaSize"
                type="text"
                :label="$t('area.space')"
                solo
                dense
                hide-details
                clearable
                multiple
                item-text="text"
                item-value="text"
                class="custom-select"
                content-class="custom-dropdown"
                :no-data-text="$t('noinfo')"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="selectFilterAreaSizeAll">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item @click="toggleItemAreaSize(item)">
                    <v-list-item-action class="me-1">
                      <v-checkbox
                        :input-value="filterData.areaSize.some(selected => selected.value === item.value)"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </td>
            <td class="ps-0">
              <v-autocomplete
                v-model="filterData.products"
                :items="[
                  ...filterOption.productCategories,
                  ...filterOption.products,
                ]"
                item-text="text"
                item-value="value"
                return-object
                :label="$t('product.title')"
                solo
                dense
                hide-details
                :no-data-text="$t('product.no_product_that_specify')"
                multiple
                :menu-props="{ bottom: true, offsetY: true }"
                class="custom-select"
                content-class="custom-dropdown"
                clearable
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="selectFilterProductAll">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item ripple @click="toggleItemProduct(item)">
                    <v-list-item-action class="me-1">
                      <v-checkbox
                        :input-value="filterData.products.some(selected => selected.value === item.value)"
                        color="primary">
                      </v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </td>
            <td class="ps-0">
              <v-text-field
                v-model="filterData.businessName"
                type="text"
                :label="$t('area.shop_name')"
                solo
                dense
                hide-details>
              </v-text-field>
            </td>
            <td class="ps-0">
              <v-text-field
                v-model="filterData.customerName"
                type="text"
                :label="$t('contract.contractor_name')"
                solo
                dense
                hide-details>
              </v-text-field>
            </td>
            <td>
              <v-select
                v-model="filterData.status"
                item-text="text"
                clearable
                item-value="text"
                multiple
                :items="filterOption.status"
                type="text"
                :label="$t('status')"
                solo
                dense
                hide-details
                class="custom-select"
                :menu-props="{ bottom: true, offsetY: true }"
                content-class="custom-dropdown"
                :no-data-text="$t('noinfo')"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="selectFilterStatusAll">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item @click="toggleItemStatus(item.text)">
                    <v-list-item-action class="me-1">
                      <v-checkbox :value="filterData.status.includes(item.text)"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </td>
            <td></td>
          </tr>
        </template>

        <template v-slot:item.name="{ item }">
          <div class="text-truncate">
            {{ item.name }}
          </div>
        </template>
        <template v-slot:item.currentProducts="{ item }">
          <template v-if="item.areaBooking">

            <template v-if="item.areaBooking.products &&
              item.areaBooking.products.length > 0
              ">
              <div :class="[{ 'd-flex align-start justify-between overflow-hidden': !showMoreChips[item.objectId] }]">
                <div :class="[
                  'chip-container',
                  { expanded: showMoreChips[item.objectId] },
                ]" :ref="'chipContainer_' + item.objectId">
                  <template v-if="!showMoreChips[item.objectId]">
                    <v-chip
                      outlined
                      class="m-1 text-xs leading-5 product-item"
                      v-for="product in item.areaBooking.products.slice(0, 7)" :key="`1-${product.objectId}`"
                    >
                      {{ product.name }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip
                      outlined
                      class="m-1 text-xs leading-5 product-item"
                      v-for="product in item.areaBooking.products" :key="`2-${product.objectId}`"
                    >
                      {{ product.name }}
                    </v-chip>
                  </template>
                </div>

                <div class="cursor-pointer icon-more" @click="toggleMoreChip(item.objectId)">
                  <div v-if="!showMoreChips[item.objectId]">
                    <v-tooltip top color="bgTooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" icon class="my-2">mdi-dots-horizontal</v-icon>
                      </template>
                      <div class="box-tooltip max-w-100">
                        <div class="text-center">{{ $t('view_all_data') }}</div>
                      </div>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    <div class="text-end text-green" color="success">{{ $t('short_data') }}</div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <span>-</span>
            </template>

          </template>
          <template v-else>
            <template v-if="item.products && item.products.length > 0">
              <div :class="[{ 'd-flex align-start justify-between overflow-hidden': !showMoreChips[item.objectId] }]">
                <div :class="[
                  'chip-container',
                  { expanded: showMoreChips[item.objectId] },
                ]" :ref="'chipContainer_' + item.objectId">
                  <template v-if="!showMoreChips[item.objectId]">
                    <v-chip
                      outlined
                      class="m-1 text-xs leading-5 product-item"
                      v-for="product in item.products.slice(0, 7)" :key="`3-${product.objectId}`"
                    >
                      {{ product.name }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip
                      outlined
                      class="m-1 text-xs leading-5 product-item"
                      v-for="product in item.products" :key="`4-${product.objectId}`"
                    >
                      {{ product.name }}
                    </v-chip>
                  </template>
                </div>
                <div class="cursor-pointer icon-more" @click="toggleMoreChip(item.objectId)">
                  <div v-if="!showMoreChips[item.objectId]">
                    <v-tooltip top color="bgTooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" icon class="my-2">mdi-dots-horizontal</v-icon>
                      </template>
                      <div class="box-tooltip max-w-100">
                        <div class="text-center">{{ $t('view_all_data') }}</div>
                      </div>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    <div class="text-end text-green" color="success">{{ $t('short_data') }}</div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <span>-</span>
            </template>
          </template>
        </template>
        <template v-slot:item.size="{ item }">
          <div class="text-end">
            {{ item.size }}
          </div>
        </template>
        <template v-slot:item.businessName="{ item }">
          <div class="business-name text-truncate">
            {{
              item.areaBooking
              ? item.areaBooking.booking.businessName || "-"
              : item.businessName
            }}
          </div>
        </template>
        <template v-slot:item.contractName="{ item }">
          <div v-if="item.contract" class="text-truncate">
            <v-tooltip top color="bgTooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="item.isConnected"
                  v-bind="attrs"
                  v-on="on"
                  size="18"
                  right
                  color="primary"
                >mdi-account-check
                </v-icon>
              </template>
              <span>{{ $t('area.connected_to_application') }}</span>
            </v-tooltip>
            {{ item.contractName }}
          </div>
          <div v-else-if="item.areaBooking &&
            item.areaBooking.booking &&
            item.areaBooking.booking.customer
            " class=" text-truncate">
            <v-tooltip top color="bgTooltip" v-if="item.areaBooking.booking.customer.isConnected">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="18" right :color="'info'">{{ "mdi-account-badge" }}</v-icon>
              </template>
              <span>{{ $t('area.connected_to_application_daily') }}</span>
            </v-tooltip>
            {{ fullName(item.areaBooking.booking.customer) }}
          </div>
        </template>
        <template v-slot:item.statusPrepare="{ item }">
          <div class="d-flex flex-nowrap">
            <div v-for="(st, inx) in item.statusPrepare">
              <v-tooltip top color="bgTooltip"
                v-if="st.value == 'isEmpty' || st.value == 'isContractSuspension' || st.value == 'isNoOutStanding' || st.value == 'isOutStanding' || st.value == 'isBadDebt'">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    class="chip-status mr-2 my-1"
                    :class="item.statusClassColor">
                    <v-icon left x-small
                  > mdi-circle
                  </v-icon>
                    {{ item.statusText }}
                  </v-chip>
                </template>
                <div class="box-tooltip">
                  <div class="text-center">
                    {{ st.text }}
                  </div>
                </div>
              </v-tooltip>

              <v-tooltip top color="bgTooltip" v-if="st.value == 'isBooking'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickDialogGoTo(item, 'AreaBooking')"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="my-1"
                  >
                    <img width="31" :src="require(`../assets/images/booking-stall-icon.svg`)" />
                  </v-btn>
                </template>
                <div class="box-tooltip">
                  <div class="box-tooltip-header">{{ $t('booking.booking_area') }}</div>
                  <div class="border-b"></div>
                  <div class="box-tooltip-footer">
                    <div v-if="getCounting(item.objectId, 'dailyBooking') > 0" class="box-tooltip-footer-detail">
                      <span>{{ $t('booking.daily_booking') }}</span>
                      <span>{{ getCounting(item.objectId, "dailyBooking") }} {{ $t('booking.booking') }}</span>
                    </div>
                    <div v-if="getCounting(item.objectId, 'monthlyBooking') > 0" class="box-tooltip-footer-detail">
                      <span>{{ $t('booking.monthly_booking') }}</span>
                      <span>{{ getCounting(item.objectId, "monthlyBooking") }} {{ $t('booking.booking') }}</span>
                    </div>
                  </div>
                </div>
              </v-tooltip>

              <v-tooltip top color="bgTooltip" v-if="st.value == 'isDaily'">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" class="chip-status info mr-2 my-1">
                    <v-icon left x-small> mdi-circle </v-icon>
                    {{ $t('daily') }}
                  </v-chip>
                </template>
                <div class="box-tooltip">
                  <div class="text-center">{{ $t('area.daily_renter_market') }}</div>
                </div>
              </v-tooltip>

              <v-tooltip top color="bgTooltip" v-if="st.value == 'isInterested'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickDialogGoTo(item, 'AreaInterest')"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="my-1"
                  >
                    <img width="31" :src="require(`../assets/images/areaInterest-icon.svg`)" />
                  </v-btn>
                </template>
                <div class="box-tooltip">
                  <div class="box-tooltip-header">{{ $t('area.area_interest') }}</div>
                  <div class="border-b"></div>
                  <div class="box-tooltip-footer">
                    <div div class="box-tooltip-footer-detail">
                      <span>{{ $t('area.area_interest_amount') }}</span>
                      <span>{{ getCounting(item.objectId, "areaInterest") }} {{ $t('people') }}</span>
                    </div>
                  </div>
                </div>
              </v-tooltip>

              <v-tooltip v-if="st.value == 'isPayment'" top color="bgTooltip" class="my-1">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickDialogGoTo(item, st.dialog)"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      class="my-1"
                    >
                    <img width="31" :src="require(`../assets/images/money-approve.svg`)" />
                  </v-btn>
                </template>
                <div class="box-tooltip">
                  <div class="text-center">{{ $t('payment.payment_notification') }}</div>
                </div>
              </v-tooltip>

              <v-tooltip v-if="st.value == 'isOverdueBill'" top color="bgTooltip" class="my-1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="my-1"
                    @click="clickDialogGoTo(item, 'Bill')"
                  >
                    <img width="31" :src="require(`../assets/images/overdue.svg`)" />
                  </v-btn>
                </template>
                <div class="box-tooltip">
                  <div class="text-center">
                    {{ $t('bill.overdue_bill') }}
                    <span v-if="item.contract && item.contract.objectId && summaryData.invoice[item.contract.objectId]"
                      class="text-red">
                      {{ $t('payment.overdue_payment_day', { time: $helper.diffDays(summaryData.invoice[item.contract.objectId][0].dueDate) }) }}
                    </span>
                    <span
                      v-if="item.areaBooking && item.areaBooking.booking && item.areaBooking.booking.objectId && summaryData.invoice[item.areaBooking.booking.objectId]"
                      class="text-red">
                      {{ $t('payment.overdue_payment_day', { time: $helper.diffDays(summaryData.invoice[item.areaBooking.booking.objectId][0].dueDate) }) }}
                    </span>
                  </div>
                </div>
              </v-tooltip>

              <v-tooltip top color="bgTooltip" v-if="st.value === 'isAlmostExpired'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="my-1"
                    @click="openRenewContract(item)"
                  >
                    <img width="31" :src="require(`../assets/images/contract-expire-1.svg`)" />
                  </v-btn>
                </template>
                <div class="box-tooltip">
                  <div class="text-center">
                    <span>{{ st.text }}</span>
                    <span class="text-red ms-2">{{ st.dateExprired ? st.dateExprired + ` ${$t('day')}` : `${$t('date_range.today')}` }} </span>
                  </div>
                </div>
              </v-tooltip>

              <v-tooltip top color="bgTooltip" v-if="st.value === 'isContractExpired'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="my-1"
                    @click="openRenewContract(item)"
                  >
                    <img width="31" :src="require(`../assets/images/contract-expire-2.svg`)" />
                  </v-btn>
                </template>
                <div class="box-tooltip">
                  <div class="text-center">
                    <span>{{ st.text }}</span>
                  </div>
                </div>
              </v-tooltip>


              <v-tooltip top color="#EEB75EE5" v-if="st.value === 'isLessThanMeter'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="my-1"
                    @click="clickDialogGoTo(item, 'MeterDigital')"
                  >
                    <img width="31" :src="require(`../assets/images/meterprepaid.svg`)" />
                  </v-btn>
                </template>
                <div class="box-tooltip">
                  <div class="box-tooltip-header gray-text">{{ $t('meter.topup_meter') }}</div>
                  <div class="border-b"></div>
                  <div class="box-tooltip-footer">
                    <div div class="box-tooltip">
                      <div v-for="(meter,inx) in summaryData.meter[item.objectId]">
                        <span v-if="inx == 0" class="gray-text">
                          <b>{{ $t('meter.title') }}</b>
                          {{ $t('meter.your_meter_is_less_than_minimum_unit') }}</span>
                        <span class="text-red"><b> {{ meter.lowUnit }} {{ $t('unit') }}</b></span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-tooltip>

            </div>
          </div>
        </template>

        <template v-slot:item.objectId="{ item }">
          <!-- <v-btn rounded small elevation="0" @click="clickDialogArea(item)">รายละเอียด</v-btn> -->
          <v-btn
            class="btn-detail-stall"
            small
            outlined
            elevation="0"
            @click="clickDialogGoTo(item)"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <AreaDialog v-model="areaDialog" :area="areaObject"></AreaDialog>
    <contract-detail-dialog :areaObject="areaObject" v-model="dialog" :show-area="false" @reloadContract="reloadContract"
      :projectId="projectId" :marketId="marketId" :contractId="contractId" :initTab="initTab" :showAreaHistoryButton="true"></contract-detail-dialog>
    <form-contract event="create" v-model="addContractDialog" :areaObject="areaObject" :customer="contractCustomer"
      @onCreateSuccess="$emit('reloadContract')" @areaProduct="getAreaProductDialog"></form-contract>
    <select-customer v-model="selectCustomerDialog" @select="createContractDialog"></select-customer>
  </div>
</template>

<script>
import { Customer } from "../classes/Customer.class";
import ContractDetailDialog from "./ContractDetailDialog";
import AreaDialog from "./AreaDialog.vue";
import FormContract from "./FormContract.vue";
import SelectCustomer from "./SelectCustomer.vue";
import FormCustomer from "./FormCustomer.vue";
import RenewContracts from "./RenewContracts.vue";
import CheckinWarning from "./CheckinWarning.vue";
import { mapGetters, mapMutations, mapState } from "vuex";
import ExplanationStatus from "./ExplanationStatus.vue";
import CheckMeterOffline from "./CheckMeterOffline.vue";
export default {
  components: {
    ContractDetailDialog,
    AreaDialog,
    FormContract,
    SelectCustomer,
    FormCustomer,
    RenewContracts,
    CheckinWarning,
    ExplanationStatus,
    CheckMeterOffline,
  },
  name: "Areas",
  computed: {
    ...mapGetters({
      customer: "customer/getCustomer",
      contract: "contract/getContract",
      getMarketSetting: "markets/getMarketSetting",
    }),
  },
  watch: {
    areas: {
      handler(areas) {
        this.initData()
        this.shouldShowMoreChip();
      },
      deep: true,
    },
    'summaryData.meter': {
      handler() {
        this.initData()
      },
      deep: true,
    },
    isLoadingSummary(value){
      if(!value){
        this.initData()
      }
    },
    filterData: {
      handler(val) {
        if (this.$refs.dataTableAreas?.$children[0]) {
          this.currentTable = this.$refs.dataTableAreas?.$children[0];
        }
        this.shouldShowMoreChip();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.shouldShowMoreChip();
  },
  data() {
    return {
      currentTable: null,
      objectId: "",
      interestId: "",
      dialog: false,
      addAreaProductShow: false,
      areaDialog: false,
      areaObject: {},
      addContractDialog: false,
      selectCustomerDialog: false,
      contractCustomer: {},
      isLoading: false,
      forceUpdateState: 0,
      areaHeaders: [],
      areaItems: [],
      filterData: {
        areaName: null,
        areaSize: [],
        products: [],
        businessName: null,
        customerName: null,
        status: [],
      },
      filterOption: {
        areaSize: [],
        products: [],
        status: [],
        productCategories: [],
      },
      isAreaProduct: false,
      areaProductObj: {},
      contractId: "",
      initTab: "",
      showMoreChips: {},
      initialVisibleCount: 3,
      maxHeightChipBox: 40,
      bookingItems: null,
      openRenewDialog : false,
      selectedRenewItem : null,
      meters : null,
      digitalMeterDataList : null,
      hashDigitalMetersUnit : null,
      formMeterDate : null,
      hashMeters : null,
    };
  },
  props: {
    areas: Array,
    search: String,
    projectId: String,
    marketId: String,
    bookingArea: Array,
    summaryData : Object,
    isLoadingSummary : Boolean,
    meterNotification: Object,
  },
  created() {
    this.areaHeaders = [
      {
        text: this.$t('rank'),
        value: "order",
        align: "center",
        width: "60px",
      },
      {
        text: this.$t('area.stall_name_and_number_only'),
        value: "name",
        width: "1%",
        class: "custom-sort",
        align: "center text-truncate hd-resize area-name text-center",
        filter: (d) =>
          this.filterData.areaName
            ? d.toLowerCase().includes(this.filterData.areaName.toLowerCase())
            : d,
      },
      {
        text: this.$t('area.area_size_square_meter_space'),
        value: "size",
        width: "120px",
        align: "center",
        filter: (d) => {
          if (this.filterData.areaSize?.length) {
            const areaSize = this.filterData.areaSize.map((s) => s.value);
            const parsedArray = Array.isArray(d) ? d : String(d).split(',');
            return parsedArray.some((item) => areaSize.includes(item));
          }
          return true;
        },
      },
      {
        text: this.$t('product.title'),
        value: "currentProducts",
        width: "250px",
        align: "center",
        sortable: false,
        filter: (d) => {
          if (this.filterData.products?.length) {
            const selectedProducts = this.filterData.products
              .filter((p) => p.type === "product")
              .map((p) => p.productName);

            const selectedCategories = this.filterData.products
              .filter((p) => p.type === "category")
              .map((p) => p.categoryName);
            return d.some(
              (item) =>
                selectedProducts.includes(item.name) ||
                selectedCategories.includes(item.productCategory?.name)
            );
          }
          return true;
        },
      },
      {
        text: this.$t('area.shop_name'),
        value: "businessName",
        width: "1%",
        align: "center text-truncate hd-resize area-name text-center",
        sortable: false,
        filter: (d) =>
          this.filterData.businessName
            ? d
              .toLowerCase()
              .includes(this.filterData.businessName.toLowerCase())
            : d,
      },
      {
        text: this.$t('contract.contractor_name'),
        value: "contractName",
        width: "1%",
        align: "center hd-resize customer-name text-truncate",
        sortable: false,
        filter: (d) =>
          this.filterData.customerName
            ? d
              .toLowerCase()
              .includes(this.filterData.customerName.toLowerCase())
            : d,
      },
      {
        text: this.$t('status'),
        value: "statusPrepare",
        width: "auto",
        align: "center",
        sortable: false,
        filter: (statusPrepare) => {
          if (this.filterData.status?.length) {
            return this.filterData.status.some((filterStatus) =>
              statusPrepare.some((item) => item.text === filterStatus)
            );
          }
          return true;
        },
      },
      {
        text: "",
        value: "objectId",
        sortable: false,
      },
    ];
    this.initData();
  },
  methods: {
    ...mapMutations({
      setCurrentArea: "area/setCurrentArea",
    }),
    initData() {
      this.areaItems = [];
      this.filterOption.areaSize = [];
      this.filterOption.productCategories = [];
      this.filterOption.products = [];
      let hashCategory = {};
      let hashProduct = {};

      for (const area of this.areas || []) {
        let sz = this.filterOption.areaSize.find((a) => a == area.size);
        if (!sz) this.filterOption.areaSize.push({ text: area.size, value: area.size });
        for (const pdt of area.currentProducts) {
          if (pdt.productCategory) {
            hashCategory[pdt.productCategory.objectId] = {
              value: `[${this.$t('category')}] ${pdt.productCategory.name}`,
              text: `[${this.$t('category')}] ${pdt.productCategory.name}`,
              categoryName: pdt.productCategory.name,
              type: "category",
            }
          }
          hashProduct[pdt.objectId] = {
            value: pdt.name,
            text: pdt.name,
            productName: pdt.name,
            type: "product",
          }
        }
      }
      this.filterOption.products = Object.values(hashProduct);
      this.filterOption.productCategories = Object.values(hashCategory);
      this.loadMarket();
      this.areaItems = this.areas;
      this.currentTable = {};
      this.currentTable.filteredItems = this.areaItems;
    },
    loadMarket() {
      this.prepareData();
    },
    prepareData() {
      let booking = this.summaryData.booking ? this.summaryData.booking : null;
      let invoice = this.summaryData.invoice ? this.summaryData.invoice : null;
      let meters = this.summaryData.meter ? this.summaryData.meter : null;
      let ageExpireStatus = 90;
      let checkMeterLessThan = false;
      for (const area of this.areas || []) {
        area.statusPrepare = [];

        if (this.getMarketSetting) {
          if (this.getMarketSetting.contractExpiredThresholdDays) {
            ageExpireStatus = this.getMarketSetting.contractExpiredThresholdDays
          }
        }

        if(area.areaBooking && area.areaBooking.type == 'daily'){
          area.statusPrepare.push(
            {
              text: this.$t('area.daily_renter_market'),
              value: 'isDaily',
            },
          );
        }
        if (!area.areaBooking || (area.contract && area.contract.isSuspend)) {
          let t = this.$t('area.empty_stall_not_renter');
          let v = 'isEmpty';
          if (area.status == 4) {
            t = this.$t('bill.bad_debt');
            v = 'isBadDebt';
          } if (area.status == 3) {
            t = this.$t('suspend.renter_monthly_market_that_suspend');
            v = 'isContractSuspension';
          } else if (area.status == 2) {
            t = this.$t('area.monthly_renter_market_that_not_debt');
            v = 'isNoOutStanding';
          } else if (area.status == 1) {
            t = this.$t('area.monthly_renter_market_that_have_debt');
            v = 'isOutStanding';
          }
          area.statusPrepare.push(
            {
              text: t,
              value: v,
            },
          );
        }

        if (booking && booking[area.objectId] &&
          ((booking[area.objectId] && booking[area.objectId].dailyBooking) ||
            (booking[area.objectId] && booking[area.objectId].monthlyBooking))) {
          area.statusPrepare.push(
            {
              text: this.$t('booking.have_booking_stall'),
              value: 'isBooking',
            },
          );
        }

        if (booking && booking[area.objectId] && booking[area.objectId].areaInterest) {
          area.statusPrepare.push(
            {
              text: this.$t('area.have_customer_interest_stall'),
              value: 'isInterested',
            },
          );
        }
        if (meters && meters[area.objectId]) {
          const meterList = meters[area.objectId] || [];
          if(area.areaBooking || (area.contract && area.contract.isActive)){
            if (meterList.some(mt => mt.meter.digitalMeterData && mt.meter.digitalMeterData.type === "prepaid" && mt.isLowUnit)) {
              area.statusPrepare.push({
                text: this.$t('meter.meter_is_less_than_minimum_unit'),
                value: 'isLessThanMeter',
              });
            }
            if ((area.contract && area.contract.isPaymentApprove) 
            || (area.areaBooking && area.areaBooking.booking && area.areaBooking.booking.isPaymentApprove)
            && (meterList.some(mt => mt.meter.isPaymentApprove))) {
              area.statusPrepare.push({
                text: this.$t('area.renter_notify_payment_this_stall'),
                value: 'isPayment',
                dialog : 'Bill',
              });
            } else if (meterList.some(mt => mt.meter.isPaymentApprove)) {
              area.statusPrepare.push({
                text: this.$t('area.renter_notify_payment_this_stall'),
                value: 'isPayment',
                dialog : 'MeterDigital',
              });
            }
          }
        }else{
          if ((area.contract && area.contract.isPaymentApprove) || (area.areaBooking && area.areaBooking.booking && area.areaBooking.booking.isPaymentApprove)) {
            area.statusPrepare.push(
              {
                text: this.$t('area.renter_notify_payment_this_stall'),
                value: 'isPayment',
                dialog : 'Bill',
              },
            );
          }
        }

        if ((area.contract && area.contract.objectId && invoice && invoice[area.contract.objectId]) ||
          (area.areaBooking && area.areaBooking.booking &&
            area.areaBooking.booking.objectId && invoice &&
            invoice[area.areaBooking.booking.objectId])) {
          area.statusPrepare.push(
            {
              text: this.$t('bill.overdue_bill'),
              value: 'isOverdueBill',
            },
          );
        }


        if (area.contract) {
          if (area.contract.endDate && area.contract.endDate.iso) {
            let ageExpire = this.$moment(area.contract.endDate.iso).diff(this.$moment(), "days");
            if (ageExpire < 0) {
              area.statusPrepare.push(
                {
                  text: this.$t('contract.contract_expired'),
                  value: 'isContractExpired',
                },
              );
            } else if (ageExpire == 0 ) {
              area.statusPrepare.push(
                {
                  text: this.$t('contract.contract_will_expired_in'),
                  value: 'isAlmostExpired',
                  dateExprired: ageExpire,
                },
              );
            } else if (ageExpire > 0 && ageExpire <= ageExpireStatus) {
              area.statusPrepare.push(
                {
                  text: this.$t('contract.contract_will_expired_in'),
                  value: 'isAlmostExpired',
                  dateExprired: ageExpire,
                },
              );
            }
          }
        }
        for (const st of area.statusPrepare) {
          let s = this.filterOption.status.find((a) => a.text === st.text);
          if (!s) this.filterOption.status.push({ text: st.text, value: st.value });
        }
      }
      
    },
    checkArrayHave(array = []) {
      if (array) {
        if (array.length < 1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    async createContractDialog(value) {
      this.isLoading = true;
      await this.$store.dispatch("customer/getCustomer", {
        id: value.objectId,
      });
      this.isLoading = false;
      this.addContractDialog = true;
      this.selectCustomerDialog = false;
    },
    getAreaProductDialog(obj) {
      this.isAreaProduct = true;
      this.areaProductObj = obj;
    },
    reloadContract(booking) {
      if (
        booking &&
        booking.areaBookings &&
        booking.areaBookings.length &&
        booking.areaBookings[0].area &&
        this.areaObject.objectId == booking.areaBookings[0].area.objectId
      ) {
        this.areaObject = booking.areaBookings[0].area;
        if (booking.areaBookings[0].area.contract)
          this.contractId = booking.areaBookings[0].area.contract.objectId;
      }
      this.$emit("reloadContract");
    },
    async saveProduct(val) {
      this.isAreaProduct = false;
      await this.$store.dispatch("area/updateAreaProducts", {
        id: val.area.objectId,
        productIds: val.products.map((i) => i.objectId),
      });
      this.$emit("reloadContract");
    },
    addAreaProduct() {
      this.addAreaProductShow = true;
    },
    clickDialogArea(item) {
      this.setCurrentArea(item);
      this.areaObject = item;
      this.contractId = item.contract ? item.contract.objectId : null;
      this.dialog = true;
    },
    clickDialogGoTo(item, goTo = "") {
      this.setCurrentArea(item);
      this.areaObject = item;
      this.contractId = item.contract ? item.contract.objectId : null;
      this.initTab = goTo;
      this.dialog = true;
    },
    openRenewContract(item) {
      this.openRenewDialog = true;
      this.selectedRenewItem = item;
    },
    resetDataSelected() {
      this.selectedRenewItem = null;
      this.openRenewDialog = false;
    },
    getStatus(status) {
      let data = {
        1: {
          color: "red",
          textColor: "white",
          name: this.$t('payment.pending'),
        },
        2: {
          color: "green",
          textColor: "white",
          name: this.$t('invoice.no_pending_invoice'),
        },
        3: {
          color: "#6781a8",
          textColor: "white",
          name: this.$t('suspend.suspend_sale'),
        },
        0: {
          color: "grey lighten-3",
          textColor: "grey",
          name: this.$t('area.empty_stall'),
        },
      };
      return data[status];
    },
    onRenewContract(response) {

    },
    fullName(customer) {
      return Customer.getFullNameByCustomer(customer);
    },
    getCounting(objectId, key) {
      if (
        this.summaryData.booking &&
        this.summaryData.booking[objectId]
      ) {
        return this.summaryData.booking[objectId][key] || 0;
      }
      return 0;
    },
    toggleMoreChip(objectId) {
      this.$set(this.showMoreChips, objectId, !this.showMoreChips[objectId]);
    },
    shouldShowMoreChip() {
      setTimeout(() => {
        const chipContainer = document.querySelectorAll(`.chip-container`);
        chipContainer.forEach((e) => {
          if (e.scrollHeight > 40) {
            e.nextSibling.classList.add('show')
          } else {
            e.nextSibling.classList.remove('show')
          }
        });
      }, 200);
    },
    selectFilterStatusAll() {
      if (this.filterData.status?.length === this.filterOption.status.length) {
        this.filterData.status = [];
      } else {
        this.filterData.status = this.filterOption.status.map(item => item.text);
      }
    },
    selectFilterAreaSizeAll() {
      if (this.filterData.areaSize?.length === this.filterOption.areaSize.length) {
        this.filterData.areaSize = [];
      } else {
        const combined = [
          ...this.filterOption.areaSize.map(item => ({
            text: item.text,
            value: item.value
          })),
        ];
        this.filterData.areaSize = combined.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.value === value.value
          ))
        );
      }
    },
    selectFilterProductAll() {
      const allSelected = this.filterData.products?.length ===
        (this.filterOption.products.length + this.filterOption.productCategories.length);
      if (allSelected) {
        this.filterData.products = [];
      } else {
        const combined = [
          ...this.filterOption.productCategories.map(item => ({
            type: 'category',
            categoryName: item.text,
            value: item.value
          })),
          ...this.filterOption.products.map(item => ({
            type: 'product',
            productName: item.text,
            value: item.value
          }))
        ];
        this.filterData.products = combined.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.value === value.value
          ))
        );
      }
    },
    toggleItemStatus(item) {
      const index = this.filterData.status.indexOf(item);
      if (index > -1) {
        this.filterData.status.splice(index, 1);
      } else {
        this.filterData.status.push(item);
      }
    },
    toggleItemAreaSize(item) {
      const index = this.filterData.areaSize.findIndex(
        (selected) => selected.value === item.value
      );
      if (index === -1) {
        this.filterData.areaSize.push(item);
      } else {
        this.filterData.areaSize.splice(index, 1);
      }
    },
    toggleItemProduct(item) {
      const index = this.filterData.products.findIndex(
        (selected) => selected.value === item.value
      );
      if (index === -1) {
        this.filterData.products.push(item);
      } else {
        this.filterData.products.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-dropdown .v-list-item__action {
  margin: 0 !important;
  padding: 0;
}

.stall-total {
  font-size: 24px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.5px;
}

.data-table-areas::v-deep th {
  padding: 0 !important;
}

.data-table-areas::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 10px;
    top: 15px;
  }
}

.data-table-areas::v-deep td {
  padding: 0 10px !important;
  max-width: 280px;
}

.data-table-areas::v-deep td.hd-resize {
  max-width: 200px;
}

.text-start {
  border-right: 1px solid #eee;
}

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: left;
  padding: 0;
}

.v-data-table::v-deep td.text-start {
  font-size: 1rem !important;
  text-align: left;
  padding: 0;
}

.show-area-2 {
  transition: all 0.2s;
  cursor: pointer;
  border-width: 1px !important;
  box-shadow: 10px 5px 0px 0px rgb(0 0 0 / 3%) !important;
  background: #fdfdfd !important;
}

.show-area-2:hover {
  transform: translateY(-5px);
  box-shadow: 10px 10px 0px 0px rgb(0 0 0 / 3%) !important;
  border-width: 1px !important;
  border-color: #eee !important;
}

.show-area {
  transition: all 0.2s;
  cursor: pointer;
  border-width: 1px !important;
  box-shadow: 0px 10px 0px 0px rgb(0 0 0 / 3%) !important;
}

.show-area:hover {
  transform: translateY(-10px);
  border-width: 1px !important;
  border-color: #eee !important;
  box-shadow: 0px 20px 0px 0px rgb(0 0 0 / 3%) !important;
}

.v-data-table .sticky-header {
  position: sticky;
  top: 0;
}

.text-nowrap-table.area-name,
.text-nowrap-table.product-name,
.text-nowrap-table.business-name,
.text-nowrap-table.customer-name {
  width: 100%;
  text-align: left;
  padding-left: 0;
}

.product-item {
  border-color: #595959;
  color: #595959;
}

.btn-detail-stall {
  color: #595959;
}

.gray-text{
  color:#595959;
}
.v-tooltip__content {
  & .box-tooltip.max-w-100 {
    max-width: 100px !important;
    min-width: 50px !important;
    width: 100px !important;
  }
}

.box-tooltip {
  max-width: 290px !important;
  min-width: 244px !important;

  &-header {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
  }

  &-footer {
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    display: flex;
    flex-direction: column;

    &-detail {
      display: flex;
      justify-content: space-between;
    }
  }
}

.text-green {
  color: var(--default-green);
  font-size: 14px;
}

.chip-container {
  display: flex;
  flex-wrap: wrap;
  max-height: 38px;
  transition: max-height 0.3s ease;

  &.expanded {
    max-height: unset !important;
  }
}

.box-tooltip .text-red {
  color: #D20F14;
  font-weight: bold;
}

.icon-more {
  display: none;

  &.show {
    display: block;
  }
}

.v-list-item__action {
  margin: 0 10px 0 0;
}
</style>
